// Smart category detection from product titles + tags + productType.
// Categories are dynamic — only those with ≥1 matching product are shown.

const CATEGORY_RULES = [
  // Special editions / collections (shown first as featured tabs)
  {
    key: "wm2026",
    labelDe: "WM 2026",
    labelEn: "World Cup 2026",
    labelEs: "Mundial 2026",
    featured: true,
    accent: true,
    match: (p) => {
      const hay = `${p.title || ""} ${(p.tags || []).join(" ")}`.toLowerCase();
      return /(wm|world\s*cup|fifa|host\s*nation|mundial)/i.test(hay) || /2026/.test(hay && /world|fifa|cup|wm/i.test(hay) ? hay : "");
    },
  },
  {
    key: "lion-crown",
    labelDe: "Lion Crown",
    labelEn: "Lion Crown",
    labelEs: "Lion Crown",
    featured: true,
    match: (p) => /lion\s*crown/i.test(`${p.title || ""} ${(p.tags || []).join(" ")}`),
  },
  {
    key: "lion-fierce",
    labelDe: "Lion Fierce",
    labelEn: "Lion Fierce",
    labelEs: "Lion Fierce",
    featured: true,
    match: (p) => /lion\s*fierce/i.test(`${p.title || ""} ${(p.tags || []).join(" ")}`),
  },
  // Product types (apparel)
  {
    key: "hoodies",
    labelDe: "Hoodies",
    labelEn: "Hoodies",
    labelEs: "Sudaderas",
    match: (p) => /hoodie|kapuze|sudader/i.test(`${p.title || ""} ${p.productType || ""}`),
  },
  {
    key: "tshirts",
    labelDe: "T-Shirts",
    labelEn: "T-Shirts",
    labelEs: "Camisetas",
    match: (p) => /t-?shirt|camiseta/i.test(`${p.title || ""} ${p.productType || ""}`),
  },
  {
    key: "caps",
    labelDe: "Caps",
    labelEn: "Caps",
    labelEs: "Gorras",
    match: (p) => /\b(cap|hat|m[üu]tze|gorra)\b/i.test(`${p.title || ""} ${p.productType || ""}`),
  },
  {
    key: "accessories",
    labelDe: "Accessoires",
    labelEn: "Accessories",
    labelEs: "Accesorios",
    match: (p) => /tote|bag|sticker|poster|mug|tasse|tasche/i.test(`${p.title || ""} ${p.productType || ""}`),
  },
];

/**
 * Build the list of category tabs from a product list.
 * Returns: [{ key, label, count, featured, accent, match }]
 * Only categories with at least 1 product are returned.
 */
export function buildCategories(products, lang = "de") {
  const labelKey = lang === "en" ? "labelEn" : lang === "es" ? "labelEs" : "labelDe";
  const result = [];
  for (const rule of CATEGORY_RULES) {
    const matched = (products || []).filter((p) => {
      try {
        return rule.match(p);
      } catch {
        return false;
      }
    });
    if (matched.length > 0) {
      result.push({
        key: rule.key,
        label: rule[labelKey],
        count: matched.length,
        featured: !!rule.featured,
        accent: !!rule.accent,
        match: rule.match,
      });
    }
  }
  return result;
}

/**
 * Filter products by a category key built from buildCategories().
 * null/undefined/"all" returns all products.
 */
export function filterByCategory(products, categories, activeKey) {
  if (!activeKey || activeKey === "all") return products;
  const cat = categories.find((c) => c.key === activeKey);
  if (!cat) return products;
  return products.filter((p) => {
    try {
      return cat.match(p);
    } catch {
      return false;
    }
  });
}
